import React from 'react';

const User = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8252 10.7803H14.8252C16.1513 10.7803 17.4231 11.3071 18.3607 12.2447C19.2984 13.1824 19.8252 14.4542 19.8252 15.7803V21.7803C19.8252 22.3107 19.6145 22.8194 19.2394 23.1945C18.8643 23.5696 18.3556 23.7803 17.8252 23.7803H7.8252C7.29477 23.7803 6.78606 23.5696 6.41099 23.1945C6.03591 22.8194 5.8252 22.3107 5.8252 21.7803V15.7803C5.8252 14.4542 6.35198 13.1824 7.28967 12.2447C8.22735 11.3071 9.49912 10.7803 10.8252 10.7803Z"
        fill="#6B758F"
      />
      <path
        d="M12.8252 9.78027C15.0343 9.78027 16.8252 7.98941 16.8252 5.78027C16.8252 3.57113 15.0343 1.78027 12.8252 1.78027C10.6161 1.78027 8.8252 3.57113 8.8252 5.78027C8.8252 7.98941 10.6161 9.78027 12.8252 9.78027Z"
        fill="#6B758F"
      />
    </svg>
  );
};

export default User;
